import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/tickets/")({
  head: () => ({ meta: [{ title: "Support Tickets | BAZZAR 3D" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/account-tickets-index")),
});
